import { render, staticRenderFns } from "./SplitRowPreview.vue?vue&type=template&id=06c048b4&scoped=true&"
import script from "./SplitRowPreview.vue?vue&type=script&lang=js&"
export * from "./SplitRowPreview.vue?vue&type=script&lang=js&"
import style0 from "./SplitRowPreview.vue?vue&type=style&index=0&id=06c048b4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06c048b4",
  null
  
)

export default component.exports